import React from "react";
import Select from "react-select";

const AuthumSearchForm = ({
  school,
  student,
  setSchool,
  setStudent,
  searchStudents,
  resetSearch,
  schoolList
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchStudents(e);
  };

  
const handleStudentChange = (e) => {
    const value = e.target.value;
    setStudent(value);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row">
        <div className="col-9-xxxl  col-lg-9 col-12 form-group">
          <div className="row">
            <div className="col-lg-6 mt-2">
              <label htmlFor="">Select School:</label>
              <Select
                onChange={(e) => setSchool(e ? e.school_code : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_code}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_code === school)
                }
              />
            </div>
          <div className="col-lg-6 mt-2">
              <label htmlFor="">Student Name(s):</label>
              <input
                type="text"
                placeholder="Enter first or last name of student..."
                style={{ border: "1px solid grey" }}
                value={student}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group mt-4">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue mt-4 ml-2"
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>
  );
};

export default AuthumSearchForm;